import { useData } from '@app/data/repositories';
import { EventDetailScreen } from './EventDetailScreen';
import { useEventDetail } from './useEventDetail';

/** Вход карточки события. */
export function EventDetailRoute({
  eventId,
  onBack,
  onOpenCase,
  onOpenClient,
}: {
  eventId: string;
  onBack: () => void;
  onOpenCase: (caseId: string) => void;
  onOpenClient: (clientId: string) => void;
}) {
  const { db } = useData();
  const { state, actions } = useEventDetail(eventId, db);

  return (
    <EventDetailScreen
      state={state}
      actions={actions}
      onBack={onBack}
      onOpenCase={onOpenCase}
      onOpenClient={onOpenClient}
    />
  );
}
